<template>
	<div class="szjk">
		<div class="szjk_banenr"></div>
		<div class="datalist">
			<div class="top_img">
				<img src="../../assets/szjk_banner_wrods.png" >
			</div>
			<div class="content">
				<template slot="template">
					
				</template>
				<template>
					<div class="content_list">
						<el-skeleton :loading="loading" animated :count="datawrap.length">
							<template slot="template">
								<div class="content_list_item">
									<div class="content_list_icon">
										<el-skeleton-item
											variant="image"
											style="height: 40px;width: 40px;margin:0 auto 12px;"
										/>
										<el-skeleton-item style="width: 100%;" />
									</div>
									<div class="swiper-wrap">
										<div class="swiper-container">
											<el-skeleton-item
												variant="image"
												style="height: 168px;width: 284px;margin-right: 20px;"
											/>
											<el-skeleton-item
												variant="image"
												style="height: 168px;width: 284px;margin-right: 20px;"
											/>
											<el-skeleton-item
												variant="image"
												style="height: 168px;width: 284px;margin-right: 20px;"
											/>
										</div>
									</div>
								</div>
							</template>
							<template>
								<div class="content_list_item" :class="'content_list_item'+index" v-for="(item,index) in datawrap">
									<div class="content_list_icon">
										<img :src="item.icon" >
										<p>{{item.name}}</p>
									</div>
									<div class="swiper-wrap">
										<div class="swiper-container">
											<div class="swiper-wrapper">
												<div class="swiper-slide swiper-item" v-for="items in item.lists" @click="goDetail(items.bsid,items.id)">
													<img :src="items.sz_img" >
													<span class="title">{{items.title}}</span>
												</div>
												<el-empty style="margin: auto;" description="暂无数据" v-if='item.lists.length == 0'></el-empty>
											</div>
										</div>
										<div class="swiper-button-prev"></div>
										<div class="swiper-button-next"></div>
									</div>
								</div>
								<el-empty style="margin: auto;" description="暂无数据" v-if='datawrap.length == 0'></el-empty>
							</template>
						</el-skeleton>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import { getdata } from '@/axios';
	import $ from 'jquery';
	import Swiper from 'swiper'
	export default{
		data(){
			return{
				oneClass:[],
				getdata:{
					mid2:1,
					page:1
				},
				loading:true,
				datawrap:[]
			}
		},
		methods:{
			// 资源列表
			datalist(){
				var that = this;
				that.datawrap = [];
				getdata.szjklist().then(res => {
					if(res.code == 200){
						if(res.data.length > 0){
							that.datawrap = res.data;
							that.loading = false;
						}
					}
				})
			},
			// 详情
			goDetail(bsid,id){
				var that = this;
				that.$router.push({
					path:"/szjkDetail",
					query:{
						id:id,
						index:this.$route.query.index
					}
				})
				// this.$emit("highLight",this.$route.query.index,id)
			}
		},
		mounted(){
			var that = this;
			that.datalist();
			setTimeout(function(){
				for(var i=0;i<that.datawrap.length;i++){
					new Swiper('.content_list_item'+i+' .swiper-container',{
						slidesPerView : 3,
						slidesPerGroup : 3,
						slidesPerColumnFill : 'row',
						navigation: {
							nextEl: '.content_list_item'+i+' .swiper-button-next',
							prevEl: '.content_list_item'+i+' .swiper-button-prev',
						},
					})
				}
			},300)
		},
		created() {
			this.$emit("highLight",this.$route.query.index,"","")
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.szjk{
		width: 100%;
		&_banenr{
			width: 100%;
			height: 540px;
			background: url(../../assets/kcsz_banner_bg.png) no-repeat;
			background-size: 100% 100%;
		}
		.datalist{
			position: relative;
			width: $indexWidth;
			margin: -485px auto 0 auto;
			.top_img{
				width: 771px;
				margin:0 auto 28px auto;
				img{
					width: 100%;
				}
			}
			.content{
				width: 100%;
				background-color: #fff;
				padding: 25px 25px;
				box-sizing: border-box;
				box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
				border-radius: 8px;
				&_list{
					width: 100%;
					font-size: 0;
					&_item{
						width: 100%;
						display: flex;
						margin-top: 35px;
						justify-content: space-between;
						align-items: center;
						.content_list_icon{
							width: 130px;
							text-align: center;
							img{
								width: 40px;
								height: 40px;
								margin: 0 auto 12px auto;
							}
							p{
								color: $indexColor2;
								font-size: 18px;
								font-weight: bold;
								font-family: $indexFontTitle;
								width: 100%;
								text-align: center;
							}
						}
						.swiper-wrap{
							position: relative;
							flex: 1;
							margin-left: 10px;
							.swiper-container{
								margin: auto;
								display: flex;
								width: 892px !important;
								box-sizing: border-box;
								padding-bottom: 35px;
								height: 100% !important;
								border-bottom: 2px solid #D8D8D8;
								.swiper-item{
									cursor: pointer;
									overflow: hidden;
									position: relative;
									height: 168px;
									width: 284px !important;
									margin-right: 20px;
									img{
										position: absolute;
										width: 100%;
										height: 100%;
										object-fit: cover;
										transition: all 0.3s;
									}
									.title{
										position: absolute;
										z-index: 11;
										width: 100%;
										line-height: 44px;
										padding: 0 16px;
										box-sizing: border-box;
										color: #fff;
										font-size: 14px;
										overflow: hidden;
										bottom: 0;
										background: rgba(56, 56, 56, 0.7);
										height: 44px;
									}
								}
								.swiper-item:hover{
									img{
										transform: scale(1.1);
									}
								}
							}
							.swiper-button-prev{
								width: 26px;
								height: 26px;
								background: url(../../assets/jkprev.png) no-repeat;
								background-size: 100% 100%;
							}
							.swiper-button-prev::after{
								content: "" !important;
							}
							.swiper-button-next{
								width: 26px;
								height: 26px;
								background: url(../../assets/jknex.png) no-repeat;
								background-size: 100% 100%;
							}
							.swiper-button-next::after{
								content: "" !important;
							}
						}
					}
					&_item:nth-child(1){
						margin-top: 0;
					}
					&_item:last-child{
						.swiper-container{
							border-bottom: none;
						}
					}
				}
			}
		}
	}
</style>
